import { effect } from '@preact/signals'
import { api } from '../lib/api.ts'
import { navigate, url } from '@01edu/signal-router'
import { user } from '../lib/session.ts'

const verifyLogin = api['GET/api/verify-login'].signal()
effect(() => {
  if (!url.params.token) return
  Promise.all([
    verifyLogin.fetch({ token: url.params.token }).then(user.reset),
    // we added a delay to avoid the page blinking too fast
    new Promise((resolve) => setTimeout(resolve, 500)),
  ]).then(async () => {
    if (verifyLogin.error) return
    // If we got here, the token was valid
    await user.fetch()
    user.error || navigate({ params: { token: null }, replace: true })
  })
})

export function VerifyLoginPage() {
  const errorMessage = (verifyLogin.error && verifyLogin.error.message) ||
    (user.error && user.error.message)

  // Determine if this is a new user invitation or regular login
  const isNewUser = user.data && 'isNewUser' in user.data
    ? user.data.isNewUser
    : false

  return (
    <div class='min-h-screen flex items-center justify-center'>
      {errorMessage
        ? (
          <div class='text-center p-8 bg-base-500 border border-error rounded-box'>
            <h2 class='text-2xl font-bold mb-4 text-error'>Login Error</h2>
            <p>The login link is invalid or has expired.</p>
            {errorMessage && (
              <p class='text-sm mt-2 text-error'>{errorMessage}</p>
            )}
            <a href='/' class='btn btn-primary mt-4'>
              Back to Login Page
            </a>
          </div>
        )
        : !user.data
        ? (
          <div class='text-center p-8 bg-base-500 border border-base-300 rounded-box'>
            <h2 class='text-2xl font-bold mb-4'>Verifying...</h2>
            <p>We're verifying your login link.</p>
            <div class='loading loading-spinner loading-lg mt-4' />
          </div>
        )
        : isNewUser
        ? (
          <div class='text-center p-8 bg-base-500 border border-success rounded-box'>
            <h2 class='text-2xl font-bold mb-4 text-success'>
              Welcome to License Hub!
            </h2>
            <p>Your account has been successfully created.</p>
            <p class='mt-2'>
              You are now logged in as <strong>{user.data.userEmail}</strong>.
            </p>
            <a href='/' class='btn btn-primary mt-4'>
              Continue to Dashboard
            </a>
          </div>
        )
        : (
          <div class='text-center p-8 bg-base-500 border border-success rounded-box'>
            <h2 class='text-2xl font-bold mb-4 text-success'>
              Login Successful
            </h2>
            <p>You have been successfully logged in.</p>
            <a href='/' class='btn btn-primary mt-4'>
              Continue to Dashboard
            </a>
          </div>
        )}
    </div>
  )
}
